import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../config/api';
import Layout from './Layout';
import { useToast } from '../contexts/ToastContext';

const DraftConvert: React.FC = () => {
  const { quoteId } = useParams<{ quoteId: string }>();
  const navigate = useNavigate();
  const { showSuccess } = useToast();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const convertDraftToCart = async () => {
      try {
        // Enable draft mode to bypass inventory restrictions
        localStorage.setItem('quoteMode', 'true');

        // Convert draft to cart
        console.log('Converting draft:', quoteId);
        const response = await api.post(`/drafts/${quoteId}/convert-to-cart`);
        console.log('Conversion response:', response.data);
        
        if (response.data.success) {
          // Show success message
          showSuccess('Draft successfully converted to cart!');
          // Redirect to cart after a delay
          setTimeout(() => navigate('/cart'), 1500);
        } else {
          setError('Failed to convert draft to cart');
          setLoading(false);
        }
      } catch (err: any) {
        console.error('Error converting quote:', err);
        setError(err.response?.data?.detail || 'Failed to convert draft to cart');
        setLoading(false);
      }
    };

    if (quoteId) {
      convertDraftToCart();
    }
  }, [quoteId, navigate]);

  if (loading) {
    return (
      <Layout>
        <div className="container mt-5">
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Converting draft to cart...</span>
            </div>
            <p className="mt-3">Converting draft to cart...</p>
          </div>
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="container mt-5">
          <div className="alert alert-danger">
            <i className="fas fa-exclamation-circle me-2"></i>
            {error}
          </div>
          <div className="text-center">
            <button 
              className="btn btn-primary me-2"
              onClick={() => navigate('/drafts')}
            >
              <i className="fas fa-arrow-left me-2"></i>Back to Drafts
            </button>
            <button 
              className="btn btn-secondary"
              onClick={() => navigate('/cart')}
            >
              <i className="fas fa-shopping-cart me-2"></i>Go to Cart
            </button>
          </div>
        </div>
      </Layout>
    );
  }

  return null;
};

export default DraftConvert;